import TitlesProps from "./Props/TitlesProps";
import { ContatoData, ContatoTitle } from "../data";
import TextProps from "./Props/TextProps";
import ButtonsContact from "./Props/ButtonsContact";
import Watermark from "../Icons/Watermark";

function Contato() {
  return (
    <section className="contact-container container animate__animated animate__fadeIn">
      <Watermark />
      <TitlesProps data={ContatoTitle} />
      <TextProps data={ContatoTitle} />
      <ButtonsContact data={ContatoData} />
    </section>
  );
}

export default Contato;
